import { Stack, Img, Box, Container, Text } from '@chakra-ui/react'
import * as ico from '.'
import { Section } from '../components/Section'

const Icons = () => {
  const arr: any[] = []
  Object.entries(ico).forEach(([key, value]) => {
    if (key.toLocaleLowerCase().endsWith('string')) {
      const i = key.lastIndexOf('String')
      arr.push({ key: key.substring(0, i), value })
    }
  })

  return (
    <Section>
      <Container>
        {/* <Stack direction='row' flexWrap='wrap'> */}
        <Box display='grid' gridTemplateColumns='repeat(auto-fill, minmax(70px, 100px))'>
          {
            arr.map(item =>
              <Box key={item.key} w={20}>
                <Text fontWeight='bold' fontSize={10}>{item.key}</Text>
                <Img w={10} src={`data:image/svg+xml;utf8,${encodeURIComponent(item.value)}`} />
              </Box>
            )
          }
        </Box>
        {/* </Stack> */}
      </Container>
    </Section>
  )
}

export default Icons